import * as _ from 'lodash-es';
import React from 'react';
import SharingDropdownSelect from './SharingDropdownSelect';
import { MenuItem, MenuItemRadio, MenuSeparator } from '../../components/Menu';
import trashIcon from '../../icons/non-prefilled/16x16/trash.svg';

const ACCESS_LEVELS = ['EDITOR', 'VIEWER'] as const;
type AccessLevel = (typeof ACCESS_LEVELS)[number];

const getTooltipProps = (message: string) =>
  ({
    disabled: true,
    tooltipPlacement: 'right',
    tooltip: message,
  }) as const;

interface SharingDropdownAccessLevelSelectProps {
  value: AccessLevel;
  onChange?: (value: AccessLevel) => void;
  onRemove?: () => void;
  changeDisabledMessage?: string;
  removeDisabledMessage?: string;
}

const SharingDropdownAccessLevelSelect = ({
  onRemove,
  removeDisabledMessage,
  changeDisabledMessage,
  value,
  onChange,
}: SharingDropdownAccessLevelSelectProps) => {
  return (
    <SharingDropdownSelect
      testId="accessLevelSelectButton"
      label={_.capitalize(value)}
      ariaLabel="Access level options"
    >
      <>
        {ACCESS_LEVELS.map((option) => (
          <MenuItemRadio
            key={option}
            checked={value === option}
            {...(changeDisabledMessage && value !== option
              ? getTooltipProps(changeDisabledMessage)
              : { onClick: onChange ? () => onChange(option) : undefined })}
          >
            {_.capitalize(option)}
          </MenuItemRadio>
        ))}
        {onRemove && <MenuSeparator />}
        {onRemove && (
          <MenuItem
            icon={trashIcon}
            danger
            {...(removeDisabledMessage
              ? getTooltipProps(removeDisabledMessage)
              : { onClick: () => onRemove() })}
          >
            Remove
          </MenuItem>
        )}
      </>
    </SharingDropdownSelect>
  );
};

export default SharingDropdownAccessLevelSelect;
